import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_ACCOUNTITEM_NEW_RECORD, GET_ACCOUNTITEM_NEW_RECORD, GET_ACCOUNT_RECORDS} from '../actions';

import {
    createAccountItemNewRecordSuccess,
    createAccountItemNewRecordError,
    getAccountItemNewRecordSuccess,
    getAccountItemNewRecordError,
    getRecordsSuccess,
    getRecordsError,
} from './actions';


// eslint-disable-next-line
const getRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();
  // eslint-disable-next-line
  const pageSize = 20;

        let recordAccountListReturned = []
        recordAccountListReturned.data = [];
        recordAccountListReturned.data.items = [];

        let item3 = [];
        item3.accountId = "4";
        item3.accountNumber = "4185-0520";
        item3.name = "CPA History and Philosophy Section Fireside Chat";
        item3.IsDefault = true 
        recordAccountListReturned.data.items.push(item3);


        //const recordRemittanceListReturned = await axios.get("vocabularies?trashed=false&search_text=" + remittanceSearchText + "&page_number=" + payload.pageNumber);

        return {
          recordList: recordAccountListReturned,
          total_item_count: recordAccountListReturned.data.total_item_count,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
};

function* getRecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      if (payload.searchInputName) {
        recordListParam.searchInputName = recordListReturned.recordList;
      }
      yield put(getRecordsSuccess(recordListParam));
    } else {
      yield put(getRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordsError(error));
  }
}


const CREATE_NEW_RECORD_ERROR = "New record success.";

const createAccountItemNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.account_id > 0)
    {
      const responseObject = await centralApiAxios.put("accounts?id="+ newRecord.account_id, newRecord);

      return {
      newsItem: responseObject.data,
      account_id: responseObject.data.account_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.account_id > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("accounts?id="+ newRecord.account_id, newRecord);

      return {
      newsItem: responseObject.data,
      account_id: responseObject.data.account_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.account_id > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createAccountItemNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createAccountItemNewRecordAsync, payload.newRecord.accountItemRecord);
      if (!resultReturned.message) {
        yield put(createAccountItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
           // history.push("/app/vocabulary-overview/"+ resultReturned.vocabulary_id);
        }
        if (payload.newRecord.catalogItemRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createAccountItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createAccountItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getAccountItemNewRecordAsync = async (payload) => {

  if (payload.account_id == 0)
  {
    return {
      accountItemRecord: undefined,
      accountId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/accounts/${  payload.account_id}?lcid=1033`);
    return {
    accountItemRecord: responseObject.data,
    accountId: responseObject.data.account_id,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getAccountItemNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getAccountItemNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getAccountItemNewRecordSuccess(resultReturned));
      } else {
        yield put(getAccountItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getAccountItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

export function* watchGetRecords() {
  yield takeEvery(GET_ACCOUNT_RECORDS, getRecordList);
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_ACCOUNTITEM_NEW_RECORD, createAccountItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetAccountItemNewRecord(newRecord) {
  yield takeEvery(GET_ACCOUNTITEM_NEW_RECORD, getAccountItemNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetAccountItemNewRecord),
        fork(watchCreateRecords),
        fork(watchGetRecords)
    ]);
}
